import axiosInstance from "../config/axiosInstance";
import { ApiRoutes } from "../constants/ApiRoutes";
import { QueryKeys } from "../constants/QueryKeys";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  individualContent,
  MakeDocumentPrimaryType,
} from "../Types/documentsTypes";
import moment from "moment";
import { generatePath } from "react-router-dom";
import { SectionAccessKeys } from "../enums/AccessPathEnums";

const DocumentServices = () => {
  const queryClient = useQueryClient();
  const {
    FETCH_QUOTE_ESTIMATE_DOCUMENTS,
    SAVE_QUOTE_ESTIMATE_DOCUMENT,
    MAKE_DOCUMENT_PRIMARY,
  } = ApiRoutes;
  const {
    FETCH_QUOTE_ESTIMATE_DOCUMENTS_KEY,
    SAVE_QUOTE_ESTIMATE_DOCUMENT_KEY,
    MAKE_DOCUMENT_PRIMARY_KEY,
  } = QueryKeys;

  const FetchDocumentDetails = (
    { isCrm = false }: { isCrm?: boolean }
  ) => {
    const fetchDocumentDetails = async () => {
      const params = isCrm ? {
        section: SectionAccessKeys.CRM,
      } : {}
      const { data } = await axiosInstance.get(FETCH_QUOTE_ESTIMATE_DOCUMENTS, {
        params: params,
      });
      return data;
    };
    return useQuery({
      queryKey: [FETCH_QUOTE_ESTIMATE_DOCUMENTS_KEY],
      queryFn: fetchDocumentDetails,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    });
  };

  const SaveDocumentAttributes = () => {
    const saveDocumentAttributes = async (payloadData: individualContent) => {
      const payload = {
        entityData: {
          ...payloadData,
          id: undefined,
          updatedAt: moment().unix(),
        },
      };
      const url = generatePath(SAVE_QUOTE_ESTIMATE_DOCUMENT, {
        id: payloadData.id,
      });
      const { data } = await axiosInstance.put(url, payload);
      return data;
    };
    return useMutation({
      mutationKey: [SAVE_QUOTE_ESTIMATE_DOCUMENT_KEY],
      mutationFn: saveDocumentAttributes,
      onSuccess: (FETCH_QUOTE_ESTIMATE_DOCUMENTS_KEY) => {
        queryClient.invalidateQueries(FETCH_QUOTE_ESTIMATE_DOCUMENTS_KEY);
      },
    });
  };

  const MakeDocumentPrimary = () => {
    const makeDocumentPrimary = async (
      payloadData: MakeDocumentPrimaryType,
    ) => {
      const url = generatePath(MAKE_DOCUMENT_PRIMARY, { id: payloadData.id });
      const payload = {
        entityData: {
          contentType: payloadData.docType,
        },
      };
      const { data } = await axiosInstance.put(url, payload);
      return data;
    };
    return useMutation({
      mutationKey: [MAKE_DOCUMENT_PRIMARY_KEY],
      mutationFn: makeDocumentPrimary,
    });
  };
  return {
    FetchDocumentDetails,
    SaveDocumentAttributes,
    MakeDocumentPrimary,
  };
};

export default DocumentServices;
